import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBug, faComments, faBookBookmark } from '@fortawesome/free-solid-svg-icons';
import commonFunc from './../common'
var _ = require('lodash');

function BubbleButton(props) {
  // const location = useLocation();
  // const [favoritePage, setFavoritePage] = useState(false)

  const handleOpenModal = () => {
    document.getElementById('report-issue-title').value = ''
    document.getElementById('report-issue-description').value = ''
    document.getElementById('report-issue-modal-btn').click()
  }
  // const handleFavorite = () => {
  //   let currentFavorites = localStorage.getItem('my-favorites');
  //   if (currentFavorites) {
  //     currentFavorites = JSON.parse(currentFavorites)
  //   } else {
  //     currentFavorites = []
  //   }
  //   const currentPath = location.pathname
  //   if (currentFavorites.includes(currentPath)) {
  //     _.remove(currentFavorites, (e) => e === currentPath)
  //     commonFunc.notifySuccess('Removed from Bookmark successfully!')
  //     setFavoritePage(false)
  //   } else {
  //     currentFavorites.push(currentPath)
  //     commonFunc.notifySuccess('Added to Bookmark successfully!')
  //     setFavoritePage(true)
  //   }
  //   localStorage.setItem('my-favorites', JSON.stringify(currentFavorites))
  // }

  const handleShare = () => {
    const el = document.createElement('input');
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  // useEffect(() => {
  //   const currentPath = location.pathname
  //   let currentFavorites = localStorage.getItem('my-favorites');
  //   if (currentFavorites) {
  //     currentFavorites = JSON.parse(currentFavorites)
  //   } else {
  //     currentFavorites = []
  //   }
  //   const thisPathIsFavorite = currentFavorites.includes(currentPath)
  //   setFavoritePage(thisPathIsFavorite)
  // }, [location])

  return (
    <>
      <div data-dial-init="" className="fixed end-6 bottom-6 group">
        <div
          id="speed-dial-menu-default"
          className="flex flex-col items-center hidden mb-4 space-y-2"
        >
          <button
            type="button"
            data-tooltip-target="tooltip-share"
            data-tooltip-placement="left"
            onClick={handleShare}
            className="flex justify-center items-center w-[52px] h-[52px] text-gray-500 hover:text-gray-900 bg-white rounded-full border border-gray-200 dark:border-gray-600 shadow-sm dark:hover:text-white dark:text-gray-400 hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-600 focus:ring-4 focus:ring-gray-300 focus:outline-none dark:focus:ring-gray-400"
          >
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 18 18"
            >
              <path d="M14.419 10.581a3.564 3.564 0 0 0-2.574 1.1l-4.756-2.49a3.54 3.54 0 0 0 .072-.71 3.55 3.55 0 0 0-.043-.428L11.67 6.1a3.56 3.56 0 1 0-.831-2.265c.006.143.02.286.043.428L6.33 6.218a3.573 3.573 0 1 0-.175 4.743l4.756 2.491a3.58 3.58 0 1 0 3.508-2.871Z" />
            </svg>
            <span className="sr-only">Share</span>
          </button>
          <div
            id="tooltip-share"
            role="tooltip"
            className="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            Copy
            <div className="tooltip-arrow" data-popper-arrow="" />
          </div>
          {/* <button
            type="button"
            data-tooltip-target="tooltip-favorites"
            data-tooltip-placement="left"
            onClick={handleFavorite}
            className="flex justify-center items-center w-[52px] h-[52px] text-gray-500 hover:text-gray-900 bg-white rounded-full border border-gray-200 dark:border-gray-600 shadow-sm dark:hover:text-white dark:text-gray-400 hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-600 focus:ring-4 focus:ring-gray-300 focus:outline-none dark:focus:ring-gray-400"
          >
            <FontAwesomeIcon icon={faBookBookmark}/>
            <span className="sr-only">Favorite</span>
          </button>
          <div
            id="tooltip-favorites"
            role="tooltip"
            className="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            { favoritePage ? 'Unfavorite' : 'Favorite' }
            <div className="tooltip-arrow" data-popper-arrow="" />
          </div> */}
          <button
            type="button"
            data-tooltip-target="tooltip-bug-report"
            data-tooltip-placement="left"
            onClick={handleOpenModal}
            className="flex justify-center items-center w-[52px] h-[52px] text-gray-500 hover:text-gray-900 bg-white rounded-full border border-gray-200 dark:border-gray-600 shadow-sm dark:hover:text-white dark:text-gray-400 hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-600 focus:ring-4 focus:ring-gray-300 focus:outline-none dark:focus:ring-gray-400"
          >
            <FontAwesomeIcon icon={faBug}/>
            <span className="sr-only">Bug Report</span>
          </button>
          <div
            id="tooltip-bug-report"
            role="tooltip"
            className="absolute z-10 invisible inline-block w-auto px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            Bug Report
            <div className="tooltip-arrow" data-popper-arrow="" />
          </div>
        </div>
        <button
          type="button"
          data-dial-toggle="speed-dial-menu-default"
          aria-controls="speed-dial-menu-default"
          aria-expanded="false"
          className="flex items-center justify-center text-white bg-blue-700 rounded-full w-14 h-14 hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 focus:outline-none dark:focus:ring-blue-800"
        >
          <svg
            className="w-5 h-5 transition-transform group-hover:rotate-45"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 18 18"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 1v16M1 9h16"
            />
          </svg>
          <span className="sr-only">Open actions menu</span>
        </button>
      </div>

    </>

  )
}

export default BubbleButton;
